export function randomHelper(card: number = 1): number {
  const res = Math.floor(card * Math.random()) + 1;

  if (res === card + 1) {
    return randomHelper(card);
  }
  return res;
}
